module.exports = __webpack_public_path__ + "img/adas.a77d2f39.png";